<template>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title"><b>
            <!-- {{ id ? "Update" : "Add" }} -->
              Add {{ type=="ST" ? "Teacher" : "Student" }}</b></p>
      </header>
      <section class="modal-card-body">
        <div class="columns is-multiline">
          <div class="column is-6">
            <b-field label="Name *">
              <b-input
                type="text"
                placeholder="Name"
                v-model="schoolUser.name"
                required
              ></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Email *">
              <b-input
                type="text"
                placeholder="Email"
                v-model="schoolUser.email"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Mobile *">
              <b-input
                type="text"
                placeholder="Mobile"
                v-model="schoolUser.mobile"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-6">
            <b-field label="Password *">
              <b-input
                type="password"
                placeholder="Password"
                v-model="schoolUser.password"
              ></b-input>
            </b-field>
          </div>
          <div class="column is-12">
            <b-button
              @click="proceed()"
              class="btn-center"
              type="is-primary"
              >
              <!-- {{ id ? "Update" : "Create" }}  -->
              Create {{ type=="ST" ? "Teacher" : "Student" }}</b-button
            >
          </div>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$parent.close()">
          Close
        </button>
      </footer>
    </div>
  </template>
  
  <script>
  import { mapActions, mapGetters } from "vuex";
  export default {
    name: "set-user",
    components : {
    },
    props: {
      type:{
        type:String,
      }
    },
    data() {
      return {
        schoolUser:{
            name:"",
            email:"",
            mobile:"",
            type:this.type,
            password:""
        },
      }
    },
    computed: {
      ...mapGetters(["getTeacherToken"]),
    },
    methods: {
      ...mapActions([
        "createSchoolUser",
        // "updatePO",
        // "loadPODetails",
      ]),
      proceed() {
        // if (this.id) {
        //   //For update
        //   this.updatePO({
        //     id: this.id,
        //     po: this.po,
        //     token: this.userToken,
        //   })
        //     .then(() => {
        //       this.$emit("over");
        //       this.$buefy.toast.open({
        //         message: "PO updated successfully",
        //         type: "is-success",
        //       });
        //     })
        //     .catch((err) => {
        //       this.$buefy.toast.open({
        //         message: err.response.data['msg'],
        //         type: "is-danger",
        //       });
        //     });
        // } else {
          //For new
        this.createSchoolUser({
          schoolUser: this.schoolUser,
          token: this.getTeacherToken,
        }).then(() => {
          this.$emit("over");
          this.$buefy.toast.open({
            message: "User created successfully",
            type: "is-success",
          });
        }).catch((err) => {
          this.$buefy.toast.open({
            message: err.response.data['msg'],
            type: "is-danger",
          });
        });
      }
    //   },
    },
    watch:{
    //   fetchPODetails(new_val){
    //      for(let key in this.po){
    //           this.po[key]=new_val[key]
    //      }
    //   }
    },
    async created() {
    //   if(this.id){
    //     this.loadPODetails({id:this.id,token:this.userToken})
    //   }
    },
  };
  </script>
  <style scoped>
  .button {
    flex-direction: row;
    width: 100%;
    background: #8919e7;
    color: #fff;
    gap: 1vw;
    cursor: pointer;
    position: relative;
    text-transform: capitalize;
    max-width: -webkit-fit-content;
    max-width: -moz-fit-content;
    max-width: fit-content;
    padding: 1.2vw 5vw;
    border-radius: 1.1vw;
    font-size: 1.2vw;
  }
  .button.outline {
    border: 0.063rem solid #8919e7;
    background: #fff;
    color: #000;
  }

</style>